function StorageCalculation({ days, hours, minutes, bitRateTotal, storageUnits }) {
  let durationInSeconds = days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60;
  let storageResultMBps = bitRateTotal * durationInSeconds;
  let storageResult = parseFloat((storageResultMBps / (storageUnits.factor / 1000000)).toFixed(2));
  return storageResult;
}

export default StorageCalculation;
